import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=ts"

import "./LeftMenu.vue?vue&type=style&index=0&id=740ed823&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740ed823"]])

export default __exports__